const FormLabel = ({ label }) => (
  <span className="font-bold font-sans ">{label}</span>
);

export default FormLabel;
